<!-- 由 suu 创建于 2021-06-24 星期四 -->
<template>
  <div class="grid-lottery" :style="{ backgroundImage: `url(${bgImg})` }">
    <!-- 九宫格 -->
    <div class="lottery-region">
      <div v-for="(item, index) in awards" :key="index" class="award">
        <img
          class="award-img user-btn"
          :src="formatUrl(item.url, index)"
          @click="bindClick(index)"
          alt
        />
        <div class="award-mask-region" v-if="index == current"></div>
        <img class="award-mask" :src="activeImg" v-if="index == current" />
      </div>
    </div>
    <!-- 中奖弹窗 -->
    <div
      class="lottery-pop"
      @click="showPop = false"
      v-if="showPop && award.result"
    >
      <div class="pop-mask"></div>
      <div class="pop-cent">
        <div class="c-name">{{ award.result.title }}</div>
        <img class="c-img" :src="award.result.giftUrl" alt="" />
        <div class="c-text">{{ award.result.title | formatPopText() }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import '@/common/vant.js'
export default {
  name: 'GridLottery',
  components: {},
  props: {
    // 抽奖开始
    starTime: {
      type: String,
      default: ''
    },
    //未活动未开始文案
    notStartStr: {
      type: String,
      default: "抽奖还未开始~'"
    },
    //活动已结束提示文案
    alreadyEndStr: {
      type: String,
      default: '当前不在活动时间~'
    },
    notLotteryStr: {
      type: String,
      default: '您目前没有可抽奖的次数'
    },
    // 抽奖接口
    getUrl: {
      type: String,
      default: 'member/Activity/extract'
    },
    // 抽奖结束
    endTime: {
      type: String,
      default: ''
    },
    //抽奖背景图
    bgImg: {
      type: String,
      default: 'https://cdnvue.gymcity.com.cn/uploads/pp-lot-bg?v=1'
    },
    //抽奖转动时选中的图片
    activeImg: {
      type: String,
      default: 'https://cdnvue.gymcity.com.cn/uploads/pp-lot-ac'
    },
    //抽奖开始按钮的样式
    startImg: {
      type: String,
      default: ''
    },
    //不能抽奖时的按钮样式
    offLotteryImg: {
      type: String,
      default: ''
    },
    list: {
      type: Array,
      required: true
    },
    // 剩余抽奖次数
    leftNum: {
      type: Number,
      required: true
    }
  },

  data() {
    return {
      awards: [],
      current: null, // 当前索引值
      speed: 200, // 时间->速度
      diff: 15, // 基数
      award: {}, // 抽中的奖品
      time: 0, // 当前时间戳
      timer: null, // 定时器
      moving: false, // 抽奖锁
      showPop: false, // 中奖弹窗
      stopAward: false
    }
  },
  filters: {
    formatPopText(str) {
      let res = 'wow！恭喜您抽中' + str + '，已发放至「我的奖品」中啦'
      return res
    }
  },
  computed: {},

  watch: {},

  created() {
    let arr = JSON.parse(JSON.stringify(this.list))
    arr.splice(4, 0, {
      url: this.startImg
    })
    this.awards = arr
  },

  mounted() {},

  destroyed() {},

  methods: {
    // 九宫格显示图片   主要是抽奖次数为0时 抽奖按钮图片改变
    formatUrl(url, index) {
      if (index === 4 && this.leftNum <= 0) {
        url = this.offLotteryImg
      }
      return url
    },
    bindClick(index) {
      // 4为抽奖按钮 其他跳过
      if (index !== 4) {
        return
      }
      //中间按钮没有图片则不能点击抽奖
      if (!this.awards[index].url) {
        return
      }
      this.start()
    },
    // 开始抽奖
    start() {
      // 正在转动则跳过
      if (this.moving) {
        return
      }
      if (
        this.starTime &&
        new Date(this.starTime.replace(/-/g, '/')).getTime() >
          new Date().getTime()
      ) {
        // 活动未开始
        this.$toast(this.notStartStr)
        return
      }
      if (
        this.endTime &&
        new Date(this.endTime.replace(/-/g, '/')).getTime() <
          new Date().getTime()
      ) {
        // 活动已经结束
        this.$toast(this.alreadyEndStr)
        return
      }
      this.current = this.current || 0
      this.time = Date.now()
      this.moving = true
      this.speed = 200
      this.diff = 12
      // 开始抽奖
      this.getLottery()
    },
    // 调接口获取奖品
    getLottery() {
      this.stopAward = false
      this.move()
    },
    //是否正在移动
    isMove() {
      return this.moving
    },
    // 开始转动
    move() {
      this.timer = setTimeout(() => {
        this.current++
        // 4为抽奖按钮 跳过
        if (this.current === 4) {
          this.current++
        }
        if (this.current >= this.awards.length) {
          this.current = 0
        }
        if (this.stopAward) {
          return
        }
        // 若抽中的奖品id存在，则开始减速转动
        if (this.award.id && (Date.now() - this.time) / 1000 > 3) {
          this.speed += this.diff // 转动减速
          // 若转动时间超过4秒，并且奖品id等于小格子的奖品id，则停下来
          if (
            (Date.now() - this.time) / 1000 > 6 &&
            this.award.id === this.awards[this.current].id
          ) {
            clearTimeout(this.timer)
            setTimeout(() => {
              //   this.$Toast(`恭喜中奖${this.award.name}`)
              this.time = 0
              // this.current = 0
              this.moving = false
              this.showPop = true
            }, 500)
            return
          }
        } else {
          // 若抽中的奖品不存在，则加速转动
          this.speed -= this.diff
        }
        this.move()
      }, this.speed)
    },
    //抽奖成功
    success(id) {
      for (let i = 0; i < this.awards.length; i++) {
        if (this.awards[i].id === id) {
          this.award = this.awards[i]
          break
        }
      }
      this.start()
    },
    //抽奖失败
    fail() {
      this.stopAward = true
      this.moving = false
    }
  }
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 750) * 100vw;
}
.grid-lottery {
  overflow: hidden;
  width: 89.6vw;
  height: 85.2vw;
  box-sizing: border-box;
  border-radius: 5.3vw;
  // width: 100%;
  // min-height: 100%;
  background-size: 100% auto;
  background-repeat: no-repeat;
  font-size: vw(26);
  position: relative;
  // 作用: 禁用弹窗里的滑动影响页面滑动
  &.prohibit {
    width: 100%;
    height: 100%;
    overflow: hidden;
  }
  // 设置占位符字体颜色
  // input::-webkit-input-placeholder {
  //   color: #a4a5a6;
  //   font-size: vw(26);
  // }
  // padding: vw(100) vw(0);
  .lottery-region {
    width: 100%;
    box-sizing: border-box;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 0 8.3vw;
    margin-top: 8.3vw;
    .award {
      width: 23.5vw;
      height: 21.3vw;
      border-radius: 1.6vw;
      text-align: center;
      float: left;
      overflow: hidden;
      // position: absolute;
      position: relative;
      margin-bottom: 0.8vw;
      .award-img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
      .award-mask {
        // width: 100%;
        // height: 100%;
        width: vw(208);
        height: vw(194);
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }
      .award-mask-region {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        border-radius: 10px;
        background-color: #fff0bd;
        opacity: 0.6;
      }
    }
  }
  // 中奖弹窗
  .lottery-pop {
    .pop-mask {
      background-color: #000;
      position: fixed;
      top: 0;
      left: 0;
      opacity: 0.6;
      width: 100%;
      height: 100%;
      z-index: 99;
    }
    .pop-cent {
      text-align: center;
      width: vw(750);
      height: vw(858);
      background: url('https://cdnvue.gymcity.com.cn/uploads/grid-lottery-bg?v=1')
        no-repeat center/100%;
      position: fixed;
      z-index: 100;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -60%);
      box-sizing: border-box;
      .c-name {
        margin-top: 52.7vw;
        font-size: 3.2vw;
        font-weight: 600;
        color: rgba(0, 0, 0, 0.7);
      }
      .c-img {
        height: 32.3vw;
        margin: 0 auto;
      }
      .c-text {
        width: 56.3vw;
        height: 10.7vw;
        font-size: 3.2vw;
        line-height: 5.3vw;
        color: #9e6434;
        margin: 0 auto;
        margin-top: 2.7vw;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-wrap: wrap;
      }
    }
  }
}
</style>
